import LocalizedStrings from "react-localization";

export const AllmappingsFiltersStrings = new LocalizedStrings({
  en: {
    mediaId: "Media Id ",
    mediaLabel: "Media Label",
    DataProvider: "Data Provider",
    DisplayMediaType: "Display Media",
    bisId: "BIS Id ",
    bisLabel: "BIS Label",
    search: "Search",
  },
  fr: {
    mediaId: "Id Media ",
    mediaLabel: "Libellé Media ",
    DataProvider: "Fournisseur de données",
    DisplayMediaType: "Display Media",
    bisId: "Id BIS",
    bisLabel: "BIS Libellé",
    search: "Recherche",
  },
});

export default AllmappingsFiltersStrings;
